import React, { useState, useEffect } from "react";
import { config } from "./config"; // 加载配置
import "@aws-amplify/ui-react/styles.css";
import "./Test.css";
import {
  fetchData,
  insertData,
  fetchData_from_patient,
  insertDataToPatientDB,
} from "./DataFetcher";
import {
  AppointmentFormFirst,
  QueryForm,
  Notification,
  AppointmentFormFollow,
} from "./Form";

import { useLocation } from "react-router-dom";
import {
  Flex,
  Button,
  View,
  Text,
  SelectField,
  Radio,
  RadioGroupField,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@aws-amplify/ui-react";

const daysOfWeek = config.daysOfWeek;
const numberOfWeeks = config.numberOfWeeks;
const debug = config.debug();
const today = config.getUTC8Time();

const Test = ({ user }) => {
  let location = useLocation();
  let clinic_name = "hansheng";
  if (location.pathname === "/yoyo") {
    clinic_name = "yoyo";
  }
  let leaveDays_temp = {
    ID: "leave",
    data: {
      hansheng: {
        "2024-09-24": ["晚診"],
        "2024-09-28": ["早診"],
      },
      yoyo: {
        "2024-09-25": ["晚診"],
      },
    },
  };
  const [leaveDays, setLeaveDays] = useState(leaveDays_temp);
  const [leaveSystem, setLeaveSystem] = useState(false);
  let onsiteDate = false;
  let clinic = clinic_name === "hansheng" ? "菡生" : "宥宥";
  const [selectedFirstFollow, setSelectedFirstFollow] = useState("first");
  const [currentWeekOffset, setCurrentWeekOffset] = useState(0);
  const [data, setData] = useState({}); // to the sorted data
  const [orginalData, setOrginalData] = useState([]); // to store the orginal fetched data

  const [registrationOrQuery, setRegistrationOrQuery] =
    useState("registration");
  const [showForm, setShowForm] = useState(false);
  const [selectDate, setSelectDate] = useState([]);
  const [selectHour, setSelectHour] = useState([]);
  const [onsite, setOnsite] = useState(false);
  // const todayUTC = new Date();
  // const today = new Date(todayUTC.getTime() + 8 * 60 * 60 * 1000);

  // 格式化日期為 "YYYY-MM-DD"
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const todayDate = `${year}-${month}-${day}`;
  // 格式化時間為 "HH:MM"
  const hours = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");

  const getWeekDates = (offset) => {
    const dates = [];
    const currentDayOfWeek = today.getDay(); // 0 (Sun) to 6 (Sat)
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - currentDayOfWeek + offset * 7); // Adjust to start from Sunday

    for (let i = 0; i <= 6; i++) {
      const date = new Date(startOfWeek);
      date.setDate(startOfWeek.getDate() + i);
      dates.push(date);
    }

    return dates;
  };

  const weekDates = getWeekDates(currentWeekOffset);

  const handleNextWeek = () => {
    setCurrentWeekOffset(currentWeekOffset + 1);
  };

  const handlePreviousWeek = () => {
    setCurrentWeekOffset(currentWeekOffset - 1);
  };

  const isCurrentWeek = weekDates.some(
    (date) => date.getTime() === today.getTime()
  );

  const handleWeekOffsetChange = (event) => {
    setCurrentWeekOffset(Number(event.target.value));
  };

  const handleAppointmentClick = (selectdDate, hour, hourData, isTwoHour) => {
    setShowForm(true);
    setSelectDate([selectdDate]);
    setSelectHour([hour, hourData]);
    setOnsite(isTwoHour);
  };

  const firstFololowButtonHandleChange = (event) => {
    setSelectedFirstFollow(event.target.value);
  };

  const handleLeaveSystem = async (ymd, hour, leave) => {
    console.log("clinic_name", clinic_name);
    console.log("ymd", ymd);
    console.log("hour", hour);
    if (!leave) {
      if (!leaveDays.data[clinic_name][ymd]) {
        leaveDays.data[clinic_name][ymd] = [];
      }
      leaveDays.data[clinic_name][ymd].push(hour);
      console.log("leaveDays", leaveDays);
    } else {
      leaveDays.data[clinic_name][ymd] = leaveDays.data[clinic_name][
        ymd
      ].filter((item) => item !== hour);
      if (leaveDays.data[clinic_name][ymd].length === 0) {
        delete leaveDays.data[clinic_name][ymd];
      }
      console.log("leaveDays after removal", leaveDays);
    }
    const result = await insertDataToPatientDB(leaveDays);
    if (result) {
      setLeaveDays(JSON.parse(JSON.stringify(leaveDays)));
    }
  };

  useEffect(() => {
    async function fetchDataAndSetState() {
      let { originalData_temp, data_temp } = await fetchData(clinic_name);
      // console.log("originalData_temp", originalData_temp);
      // console.log("data_temp", data_temp);

      setOrginalData(originalData_temp);
      setData(data_temp);
      let leaveDays_temp = await fetchData_from_patient("leave");
      // console.log("leaveDays_temp", leaveDays_temp);
      if (!leaveDays_temp) {
        setData(false); //讓data為false，讓畫面顯示"網頁目前維護中..."
        return;
      }
      if (leaveDays_temp.length === 1) {
        setLeaveDays(leaveDays_temp[0]);
      } else {
        setLeaveDays({
          ID: "leave",
          data: {
            hansheng: {},
            yoyo: {},
          },
        });
      }
    }

    fetchDataAndSetState();
  }, [clinic_name]);

  return (
    <View
      style={{
        width: "90vw",
        margin: "0 auto",
        // display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {debug && <h2>debug mode</h2>}
      {!data && (
        <View style={{ width: "100%", overflowX: "auto" }}>
          <h4>網頁目前維護中...</h4>
        </View>
      )}
      {Object.keys(data).length === 0 && (
        <View style={{ width: "100%", overflowX: "auto" }}>
          <h4>資料載入中...</h4>
        </View>
      )}
      {Object.keys(data).length > 0 && (
        <View style={{ width: "100%", overflowX: "auto" }}>
          {/* <Text as="h2">當前頁面路徑: {location.pathname}</Text> */}
          {/* <Text>{JSON.stringify(today)}</Text> */}
          <br />
          <Flex
            direction="row" // 添加方向
            justifyContent="center" // 使用 space-between 使 h4 和 Button 分開
            style={{ width: "100%" }} // 确保 Flex 容器占满宽度
          >
            <h4
              style={{
                textAlign: "center",
              }}
            >
              {clinic}兒童成長發育專科門診預約系統
            </h4>
          </Flex>

          <Flex
            direction="row"
            justifyContent="center"
            // className="button-select-container"
          >
            <Button
              onClick={() => setRegistrationOrQuery("registration")}
              isDisabled={registrationOrQuery === "registration"}
            >
              預約門診時段
            </Button>
            <Button
              onClick={() => setRegistrationOrQuery("query")}
              isDisabled={registrationOrQuery === "query"}
            >
              查詢/取消預約
            </Button>
          </Flex>

          {registrationOrQuery === "registration" && (
            <View className="content" direction="column">
              <RadioGroupField
                name="firstFollow"
                value={selectedFirstFollow}
                onChange={firstFololowButtonHandleChange}
                direction="row"
              >
                <Radio value="first">初診</Radio>
                <Radio value="follow">複診</Radio>
              </RadioGroupField>
              <Text color={"gray"}>李如浩醫師</Text>
              <Flex
                direction="row"
                // justifyContent="center"
                // className="button-select-container"
                // marginTop="-40px" // 調整這個值來縮小距離
              >
                <Button onClick={handlePreviousWeek} isDisabled={isCurrentWeek}>
                  上一週
                </Button>
                <SelectField
                  value={currentWeekOffset}
                  onChange={handleWeekOffsetChange}
                  margin="0 0px"
                >
                  {Array.from({ length: numberOfWeeks }, (_, i) => (
                    <option key={i} value={i}>
                      {i}
                    </option>
                  ))}
                </SelectField>
                <Button
                  onClick={handleNextWeek}
                  isDisabled={currentWeekOffset === numberOfWeeks - 1}
                >
                  下一週
                </Button>
              </Flex>

              <Table className="schedule-table" style={{ width: "100%" }}>
                <TableHead>
                  <TableRow className="table-head">
                    <TableCell className="no-wrap"></TableCell>
                    {weekDates.map((date, dateIndex) => (
                      <TableCell key={dateIndex} className="no-wrap">
                        {`${daysOfWeek[dateIndex]} `}
                        <br />
                        {`${date.getMonth() + 1}/${date.getDate()}`}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries({
                    早診: "09:00-11:50",
                    午診: "15:00-17:50",
                    晚診: "18:00-20:50",
                  }).map(([hour, time]) => (
                    <TableRow key={hour}>
                      <TableCell
                        style={{
                          width: "auto",
                          whiteSpace: "nowrap",
                          margin: "0px",
                          padding: "0px",
                        }}
                      >
                        {hour}
                        <br />
                        {time.split("-")[0]}
                        <br />
                        |
                        <br />
                        {time.split("-")[1]}
                      </TableCell>
                      {weekDates.map((date, dateIndex) => {
                        const ymd = `${date.getFullYear()}-${String(
                          date.getMonth() + 1
                        ).padStart(2, "0")}-${String(date.getDate()).padStart(
                          2,
                          "0"
                        )}`;
                        const hourData = data?.[ymd]?.hours?.[hour];
                        const isFullAll = hourData?.isFullAll;
                        const isFullFirst = hourData?.isFullFirst;
                        let isFull =
                          isFullAll ||
                          (selectedFirstFollow === "first"
                            ? isFullFirst
                            : isFullAll);
                        let isTwoHour = false;
                        let isEnd = false;
                        if (hourData?.show && ymd === todayDate) {
                          const currentTotalMinutes =
                            today.getHours() * 60 + today.getMinutes();
                          const [startTime, endTime] = time.split("-");
                          const [startHours, startMinutes] = startTime
                            .split(":")
                            .map(Number);
                          const startTotalMinutes =
                            startHours * 60 + startMinutes;
                          const [endHours, endMinutes] = endTime
                            .split(":")
                            .map(Number);
                          const endTotalMinutes = endHours * 60 + endMinutes;
                          isTwoHour = onsiteDate
                            ? true
                            : startTotalMinutes - currentTotalMinutes <= 120;
                          onsiteDate = isTwoHour;
                          isEnd = currentTotalMinutes - endTotalMinutes >= 60;
                        }
                        const leave =
                          leaveDays?.data?.[clinic_name]?.[ymd]?.includes(hour);

                        return (
                          <TableCell
                            key={ymd}
                            style={{
                              // backgroundColor: isFull ? "#F4A7B9" : "#A8D8B9",
                              margin: "10px",
                              // height: "150px",
                              width: "20vw",
                              Height: "30vh",
                              // padding: "0px",
                            }}
                          >
                            {hourData?.show && (
                              <>
                                {leaveSystem && (
                                  <Button
                                    style={{
                                      width: "100%",
                                      // height: "100%",
                                      margin: "0px",
                                      padding: "0px",
                                      backgroundColor: "#F5F5F5",
                                    }}
                                    onClick={() => {
                                      handleLeaveSystem(ymd, hour, leave);
                                    }}
                                  >
                                    {!leave ? "請假" : "取消請假"}
                                  </Button>
                                )}
                                {!leave ? (
                                  <Button
                                    onClick={() =>
                                      handleAppointmentClick(
                                        ymd,
                                        hour,
                                        hourData,
                                        isTwoHour
                                      )
                                    }
                                    isDisabled={
                                      isEnd ? true : isTwoHour ? false : isFull
                                    }
                                    style={{
                                      width: "100%",
                                      height: leaveSystem ? "50%" : "100%",
                                      backgroundColor: isEnd
                                        ? "#F4A7B9"
                                        : isTwoHour
                                        ? "#D2B48C"
                                        : isFull
                                        ? "#F4A7B9"
                                        : "#A8D8B9",
                                      margin: "0px",
                                      padding: "0px",
                                    }}
                                  >
                                    {isEnd
                                      ? "結束預約"
                                      : isTwoHour
                                      ? "現場號"
                                      : isFull
                                      ? "額滿"
                                      : "預約"}
                                  </Button>
                                ) : (
                                  <Button
                                    isDisabled={true}
                                    style={{
                                      width: "100%",
                                      height: leaveSystem ? "50%" : "100%",
                                      backgroundColor: "#F4A7B9",
                                      margin: "0px",
                                      padding: "0px",
                                      opacity: 0.7,
                                    }}
                                  >
                                    醫師停診
                                  </Button>
                                )}
                              </>
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {user?.account === "admin" &&
                registrationOrQuery === "registration" && (
                  <View style={{ alignSelf: "flex-end" }}>
                    <Button onClick={() => setLeaveSystem(!leaveSystem)}>
                      {leaveSystem ? "關閉請假系統" : "開啓請假系統"}
                    </Button>
                  </View>
                )}
              <Notification clinic_name={clinic} />
              {showForm && selectedFirstFollow === "first" && (
                <AppointmentFormFirst
                  showForm={showForm}
                  setShowForm={setShowForm}
                  selectDate={selectDate}
                  // insertData={insertData}
                  setData={setData}
                  setOrginalData={setOrginalData}
                  selectHour={selectHour}
                  selectedFirstFollow={selectedFirstFollow}
                  clinic_name={clinic_name}
                  setRegistrationOrQuery={setRegistrationOrQuery}
                  onsite={onsite}
                />
              )}
              {showForm && selectedFirstFollow === "follow" && (
                <AppointmentFormFollow
                  showForm={showForm}
                  setShowForm={setShowForm}
                  selectDate={selectDate}
                  // insertData={insertData}
                  setData={setData}
                  setOrginalData={setOrginalData}
                  selectHour={selectHour}
                  selectedFirstFollow={selectedFirstFollow}
                  clinic_name={clinic_name}
                  setRegistrationOrQuery={setRegistrationOrQuery}
                  onsite={onsite}
                />
              )}
            </View>
          )}
          {registrationOrQuery === "query" && (
            <View className="content">
              {/* <Text as="h1">查詢預約</Text> */}
              <QueryForm
                orginalData={orginalData}
                // deleteData={deleteData}
                setOrginalData={setOrginalData}
                setData={setData}
                data={data}
                clinic_name={clinic_name}
                user={user}
              />
            </View>
          )}
          {registrationOrQuery.startsWith("registrationCompleted") && (
            <View
              style={{
                margin: "10vw",
                border: "1px solid black",
                // textAlign: "center",
              }}
            >
              {(() => {
                const [status, date, hour, time, patient, firstFollow, onsite] =
                  registrationOrQuery.split("_");
                return (
                  <>
                    {/* <Text as="h1">預約完成</Text> */}
                    {/* <p>{registrationOrQuery}</p> */}
                    {/* <p>{details}</p> */}
                    {/* <p>恭喜成功！</p> */}
                    <p>您的預約資訊如下：</p>
                    <ul>
                      <li style={{ fontWeight: "bold" }}>姓名：{patient}</li>
                      <li style={{ fontWeight: "bold" }}>
                        診別：{firstFollow}
                      </li>
                      <li style={{ fontWeight: "bold" }}>日期：{date}</li>
                      <li style={{ fontWeight: "bold" }}>時段：{hour}</li>
                      <li style={{ fontWeight: "bold" }}>預約時間：{time}</li>
                    </ul>
                    {onsite === "true" ? (
                      <>
                        <p>請現場等候叫號</p>
                      </>
                    ) : (
                      <>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "#DB4D6D",
                            fontSize: "24px",
                            backgroundColor: "yellow",
                            display: "inline-block",
                          }}
                        >
                          請提早10分鐘至一樓掛號櫃檯報到。
                        </p>
                        <p>
                          請注意：本網頁系統預約成功後，報到時仍需在現場一樓櫃檯掛號。
                        </p>
                        <p>診所地址：</p>
                        <ul>
                          {clinic_name === "hansheng" ? (
                            <li style={{ fontWeight: "bold" }}>
                              新北市板橋區中山路一段104號
                            </li>
                          ) : (
                            <li style={{ fontWeight: "bold" }}>
                              新北市蘆洲區長榮路58號
                            </li>
                          )}
                        </ul>
                        <Notification clinic_name={clinic} />
                      </>
                    )}
                  </>
                );
              })()}
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default Test;
